import styled from "styled-components/macro";
import { focusOutline } from "../../styles/a11y";

export const StyledContainer = styled.div`
  margin-bottom: 15px;

  .slider-container {
    margin-bottom: 3px;
  }

  h3 {
    margin-bottom: 5px;
  }

  .range-labels {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    font-weight: 500;
  }

  .rc-slider-step {
    width: 96%;
    left: 2.75%;
    top: 35%;
  }

  .rc-slider-handle:focus-visible {
    ${focusOutline}
    border-radius: 50%;
  }
`;
